import { css } from '@emotion/react';
import { FC } from 'react';

type Flex = {
  type?: 'column' | 'row';
  alignItems?: string;
  justifyContent?: string;
  gap?: number;
  width?: string;
  minWidth?: string;
  wrap?: 'wrap' | 'nowrap';
  margin?: string;
  padding?: string;
  height?: string;
};

const Flex: FC<Flex> = ({
  type = 'row',
  alignItems = 'stretch',
  justifyContent = 'normal',
  gap = 0,
  children,
  width,
  minWidth,
  height,
  wrap = 'nowrap',
  margin = '0',
  padding = '0',
}) => {
  return (
    <div css={root({ alignItems, justifyContent, gap, type, width, minWidth, height, wrap, margin, padding })}>
      {children}
    </div>
  );
};

const root = ({
  alignItems = 'stretch',
  justifyContent = 'normal',
  gap,
  type = 'row',
  width,
  minWidth,
  height,
  wrap,
  margin,
  padding,
}: Flex) => css`
  flex-direction: ${type};
  display: flex;
  align-items: ${alignItems};
  justify-content: ${justifyContent};
  ${gap ? `gap: ${gap}px` : null};
  ${width && `width: ${width};`}
  ${height && `height: ${height};`}
  ${wrap && `flex-wrap: ${wrap};`}
  ${margin && `margin: ${margin};`}
  ${padding && `padding: ${padding}`};
  ${minWidth && `min-width: ${minWidth}`};
`;

export default Flex;
